module.exports = __webpack_public_path__ + "img/qr_qq.6c221a72.png";